import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.home');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-home',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.home/view.scss */
:host {
  display: block;
  height: 100%;
  --ink-950: #14212b;
  --ink-800: #2c3b46;
  --ink-650: #50616d;
  --ink-500: #71808b;
  --line-strong: #cbd5db;
  --line: #dde4e8;
  --line-soft: #edf1f3;
  --canvas: #f5f7f8;
  --surface: #ffffff;
  --surface-soft: #f9fafb;
  --navy: #12344d;
  --navy-hover: #0b2b42;
  --blue: #176b87;
  --blue-soft: #e8f3f7;
  --green: #287458;
  --green-soft: #eaf5f0;
  --amber: #966515;
  --amber-soft: #fbf3df;
  --red: #9d423c;
  --red-soft: #fbeeed;
  --violet: #66558b;
  --violet-soft: #f0edf6;
  color: var(--ink-950);
  background: var(--canvas);
  font-size: 15px;
}

* {
  box-sizing: border-box;
}

button, input, select, textarea {
  font: inherit;
}

button:focus-visible, a:focus-visible, input:focus-visible, select:focus-visible, textarea:focus-visible, [tabindex]:focus-visible {
  outline: 3px solid rgba(23, 107, 135, 0.24);
  outline-offset: 1px;
}

.clinical-shell {
  display: grid;
  grid-template-columns: 236px minmax(0, 1fr);
  min-height: 100%;
  background: var(--canvas);
}

.app-sidebar {
  position: sticky;
  top: 0;
  z-index: 30;
  display: flex;
  flex-direction: column;
  height: 100vh;
  padding: 20px 14px 16px;
  color: #dce7ed;
  background: #102d40;
  border-right: 1px solid #092538;
}

.brand-block {
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 0 8px 22px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.brand-symbol {
  display: grid;
  place-items: center;
  width: 34px;
  height: 34px;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.22);
  background: #1d536b;
}

.brand-block strong, .brand-block span {
  display: block;
}

.brand-block strong {
  font-size: 15px;
  letter-spacing: 0.01em;
}

.brand-block span {
  margin-top: 2px;
  color: #98b3c2;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.11em;
}

.sidebar-nav {
  flex: 1;
  padding-top: 18px;
}

.nav-section-label {
  margin: 0 10px 7px;
  color: #7293a4;
  font-size: 15px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.12em;
}

.nav-section-spaced {
  margin-top: 24px;
}

.sidebar-nav button {
  display: flex;
  align-items: center;
  gap: 11px;
  width: 100%;
  min-height: 40px;
  margin: 2px 0;
  padding: 0 11px;
  color: #b9ccd6;
  border: 1px solid transparent;
  border-radius: 5px;
  background: transparent;
  text-align: left;
}

.sidebar-nav button i {
  width: 17px;
  color: #86a4b4;
  text-align: center;
}

.sidebar-nav button:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.055);
}

.sidebar-nav button.active {
  color: #fff;
  border-color: rgba(115, 186, 211, 0.22);
  background: #19445b;
}

.sidebar-nav button.active i {
  color: #8cd0e6;
}

.sidebar-footer {
  padding: 14px 9px 0;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  color: #7f9caa;
  font-size: 13px;
}

.sidebar-footer p {
  margin: 6px 0 0;
}

.environment-line {
  display: flex;
  align-items: center;
  gap: 9px;
  margin-bottom: 10px;
}

.environment-line strong, .environment-line small {
  display: block;
}

.environment-line strong {
  color: #d6e2e8;
  font-size: 14px;
}

.environment-line small {
  margin-top: 2px;
  color: #829eac;
}

.health-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #5eb38e;
  box-shadow: 0 0 0 3px rgba(94, 179, 142, 0.13);
}

.app-workspace {
  min-width: 0;
}

.workspace-header {
  position: sticky;
  top: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  min-height: 66px;
  padding: 10px 28px;
  border-bottom: 1px solid var(--line);
  background: rgba(255, 255, 255, 0.97);
}

.header-leading {
  display: flex;
  align-items: center;
  gap: 11px;
  min-width: 0;
}

.breadcrumb {
  margin: 0;
  color: var(--ink-500);
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.workspace-header h1 {
  margin: 2px 0 0;
  font-size: 19px;
  line-height: 1.25;
  letter-spacing: -0.01em;
}

.header-context {
  display: flex;
  align-items: center;
  gap: 0;
}

.context-item {
  min-width: 152px;
  padding: 0 18px;
  border-right: 1px solid var(--line);
}

.context-item span, .context-item strong {
  display: block;
}

.context-item span {
  color: var(--ink-500);
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.07em;
}

.context-item strong {
  margin-top: 3px;
  color: var(--ink-800);
  font-size: 13px;
  font-weight: 600;
}

.icon-button {
  display: inline-grid;
  place-items: center;
  width: 34px;
  height: 34px;
  padding: 0;
  color: var(--ink-650);
  border: 1px solid var(--line-strong);
  border-radius: 5px;
  background: #fff;
}

.icon-button:hover {
  color: var(--navy);
  border-color: #aab9c2;
  background: var(--surface-soft);
}

.header-context .icon-button {
  margin-left: 14px;
}

.mobile-menu {
  display: none;
}

.workspace-content {
  width: min(1480px, 100%);
  margin: 0 auto;
  padding: 26px 28px 56px;
}

.page-section {
  display: grid;
  gap: 18px;
}

.page-intro {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  padding: 8px 0 3px;
}

.page-intro.compact {
  align-items: center;
}

.page-intro h2 {
  margin: 4px 0 5px;
  font-size: 26px;
  line-height: 1.2;
  letter-spacing: -0.025em;
}

.page-intro p:not(.section-kicker) {
  max-width: 740px;
  margin: 0;
  color: var(--ink-650);
  line-height: 1.55;
}

.section-kicker {
  margin: 0;
  color: var(--blue);
  font-size: 15px;
  font-weight: 750;
  text-transform: uppercase;
  letter-spacing: 0.11em;
}

.context-tag {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 11px;
  color: var(--green);
  border: 1px solid #bcd8cb;
  background: var(--green-soft);
  font-size: 16px;
  font-weight: 650;
}

.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 38px;
  padding: 0 14px;
  border: 1px solid transparent;
  border-radius: 5px;
  font-weight: 650;
  text-decoration: none;
  white-space: nowrap;
}

.button-primary {
  color: #fff;
  border-color: var(--navy);
  background: var(--navy);
}

.button-primary:hover {
  background: var(--navy-hover);
}

.button-secondary {
  color: var(--ink-800);
  border-color: var(--line-strong);
  background: #fff;
}

.button-secondary:hover {
  border-color: #9daeb8;
  background: var(--surface-soft);
}

.button-small {
  min-height: 32px;
  padding: 0 11px;
  font-size: 15px;
}

.button:disabled {
  cursor: not-allowed;
  opacity: 0.48;
}

.full-width {
  width: 100%;
}

.text-button {
  padding: 0;
  color: var(--blue);
  border: 0;
  background: transparent;
  font-size: 15px;
  font-weight: 650;
}

.surface {
  min-width: 0;
  border: 1px solid var(--line);
  border-radius: 7px;
  background: var(--surface);
}

.surface-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 17px 19px;
  border-bottom: 1px solid var(--line-soft);
}

.surface-header.stacked {
  display: block;
}

.surface-header h3 {
  margin: 3px 0 0;
  font-size: 17px;
  letter-spacing: -0.01em;
}

.surface-header p:not(.section-kicker) {
  margin: 5px 0 0;
  color: var(--ink-650);
  font-size: 15px;
}

.metric-strip {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  border: 1px solid var(--line);
  border-radius: 7px;
  background: #fff;
}

.metric-strip > div {
  min-width: 0;
  padding: 16px 19px;
  border-right: 1px solid var(--line);
}

.metric-strip > div:last-child {
  border-right: 0;
}

.metric-strip span, .metric-strip small {
  display: block;
}

.metric-strip span {
  color: var(--ink-500);
  font-size: 15px;
  font-weight: 650;
  text-transform: uppercase;
  letter-spacing: 0.07em;
}

.metric-strip strong {
  display: inline-block;
  margin-top: 5px;
  font-size: 26px;
  font-variant-numeric: tabular-nums;
}

.metric-strip small {
  margin-top: 2px;
  color: var(--ink-500);
  font-size: 16px;
}

.compact-metrics > div {
  padding-block: 13px;
}

.overview-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(360px, 0.9fr);
  gap: 18px;
}

.workflow-list {
  margin: 0;
  padding: 2px 19px 14px;
  list-style: none;
}

.workflow-list li {
  display: grid;
  grid-template-columns: 33px 1fr;
  gap: 12px;
  padding: 14px 0;
  border-bottom: 1px solid var(--line-soft);
}

.workflow-list li:last-child {
  border-bottom: 0;
}

.workflow-list li > span {
  display: grid;
  place-items: center;
  width: 28px;
  height: 28px;
  color: var(--blue);
  border: 1px solid #b8d3de;
  background: var(--blue-soft);
  font-size: 15px;
  font-weight: 750;
}

.workflow-list strong {
  display: block;
  font-size: 16px;
}

.workflow-list p {
  margin: 3px 0 0;
  color: var(--ink-650);
  font-size: 15px;
  line-height: 1.45;
}

.compact-run-list {
  padding: 4px 0;
}

.compact-run-list button {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 14px;
  width: 100%;
  padding: 14px 19px;
  color: inherit;
  border: 0;
  border-bottom: 1px solid var(--line-soft);
  background: transparent;
  text-align: left;
}

.compact-run-list button:last-child {
  border-bottom: 0;
}

.compact-run-list button:hover {
  background: var(--surface-soft);
}

.compact-run-list strong, .compact-run-list span {
  display: block;
}

.compact-run-list strong {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 15px;
}

.compact-run-list span {
  margin-top: 4px;
  color: var(--ink-500);
  font-size: 15px;
}

.compact-run-list dl {
  display: flex;
  gap: 15px;
  margin: 0;
}

.compact-run-list dl div {
  text-align: right;
}

.compact-run-list dt {
  color: var(--ink-500);
  font-size: 14px;
  text-transform: uppercase;
}

.compact-run-list dd {
  margin: 3px 0 0;
  font-size: 15px;
  font-weight: 700;
}

.semantic-reference .surface-header > p {
  max-width: 400px;
}

.semantic-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}

.semantic-grid > div {
  padding: 17px 19px;
  border-right: 1px solid var(--line-soft);
}

.semantic-grid > div:last-child {
  border-right: 0;
}

.semantic-grid p {
  margin: 9px 0 0;
  color: var(--ink-650);
  font-size: 16px;
  line-height: 1.45;
}

.semantic-badge, .status-badge {
  display: inline-flex;
  align-items: center;
  min-height: 22px;
  padding: 2px 7px;
  border: 1px solid transparent;
  border-radius: 3px;
  font-size: 15px;
  font-weight: 700;
  line-height: 1.2;
  white-space: nowrap;
}

.semantic-clinical {
  color: #1f674d;
  border-color: #b9d8ca;
  background: var(--green-soft);
}

.semantic-sensitization {
  color: #28647a;
  border-color: #bed8e3;
  background: var(--blue-soft);
}

.semantic-molecular {
  color: #62517e;
  border-color: #d3cae2;
  background: var(--violet-soft);
}

.semantic-other {
  color: #5e6870;
  border-color: #d8dfe3;
  background: #f1f4f5;
}

.status-positive {
  color: #246a51;
  border-color: #bad8cb;
  background: var(--green-soft);
}

.status-review {
  color: #8b5d12;
  border-color: #e7d19f;
  background: var(--amber-soft);
}

.status-negative {
  color: #8e3d38;
  border-color: #e5beb9;
  background: var(--red-soft);
}

.status-neutral {
  color: #596973;
  border-color: #d4dde1;
  background: #f2f5f6;
}

.message-stack {
  position: fixed;
  top: 78px;
  right: 22px;
  z-index: 70;
  display: grid;
  gap: 8px;
  width: min(460px, 100vw - 32px);
}

.inline-message {
  display: grid;
  grid-template-columns: 20px 1fr 24px;
  align-items: center;
  gap: 10px;
  padding: 12px 13px;
  border: 1px solid;
  border-radius: 5px;
  box-shadow: 0 8px 24px rgba(26, 45, 57, 0.12);
  background: #fff;
  font-size: 15px;
}

.inline-message button {
  display: grid;
  place-items: center;
  width: 24px;
  height: 24px;
  padding: 0;
  color: inherit;
  border: 0;
  background: transparent;
}

.message-error {
  color: var(--red);
  border-color: #dfb8b3;
}

.message-success {
  color: var(--green);
  border-color: #b8d5c8;
}

.upload-workbench {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 17px 19px;
}

.upload-leading {
  display: flex;
  align-items: center;
  gap: 13px;
}

.upload-icon {
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
  color: var(--green);
  border: 1px solid #c4dacd;
  background: var(--green-soft);
}

.upload-leading h3 {
  margin: 0;
  font-size: 17px;
}

.upload-leading p {
  margin: 3px 0;
  color: var(--ink-500);
  font-size: 16px;
}

.upload-leading strong {
  color: var(--ink-800);
  font-size: 16px;
}

.upload-actions {
  display: flex;
  align-items: flex-end;
  gap: 9px;
}

.file-button {
  cursor: pointer;
}

.file-button input, .drop-zone input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
}

.compact-control {
  display: grid;
  gap: 4px;
  color: var(--ink-500);
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.compact-control select {
  min-width: 76px;
  height: 38px;
  padding: 0 9px;
  color: var(--ink-800);
  border: 1px solid var(--line-strong);
  border-radius: 5px;
  background: #fff;
}

.patient-empty {
  min-height: 260px;
}

.patient-workbench {
  display: grid;
  grid-template-columns: minmax(0, 1.5fr) minmax(350px, 0.75fr);
  gap: 18px;
  align-items: start;
}

.data-disclaimer {
  margin: 0;
  padding: 10px 19px;
  color: #78601f;
  border-bottom: 1px solid #efe4c8;
  background: #fdf9ef;
  font-size: 16px;
  line-height: 1.45;
}

.table-scroll {
  overflow: auto;
}

.lab-table-wrap {
  max-height: 540px;
}

.clinical-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 15px;
}

.clinical-table th {
  position: sticky;
  top: 0;
  z-index: 2;
  padding: 10px 12px;
  color: var(--ink-500);
  border-bottom: 1px solid var(--line-strong);
  background: #f7f9fa;
  text-align: left;
  font-size: 14px;
  font-weight: 750;
  text-transform: uppercase;
  letter-spacing: 0.055em;
  white-space: nowrap;
}

.clinical-table td {
  padding: 11px 12px;
  border-bottom: 1px solid var(--line-soft);
  vertical-align: middle;
}

.clinical-table tr:last-child td {
  border-bottom: 0;
}

.clinical-table tbody tr:hover {
  background: #f8fafb;
}

.clinical-table tbody tr.selected-row {
  background: #f1f7f9;
}

.clinical-table strong {
  font-weight: 650;
}

.clinical-table small, .clinical-table span {
  display: block;
}

.clinical-table small {
  margin-top: 3px;
  color: var(--ink-500);
  font-size: 15px;
}

.select-column {
  width: 52px;
}

.muted-cell {
  color: var(--ink-500);
}

input[type=checkbox] {
  width: 15px;
  height: 15px;
  accent-color: var(--blue);
}

.relationship-panel {
  min-height: 330px;
}

.relationship-tree {
  padding: 5px 0;
}

.relationship-row {
  position: relative;
  display: grid;
  grid-template-columns: 12px 1fr 14px;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 13px 16px;
  color: inherit;
  border: 0;
  border-bottom: 1px solid var(--line-soft);
  background: transparent;
  text-align: left;
}

.relationship-row:last-child {
  border-bottom: 0;
}

.relationship-row:hover {
  background: var(--surface-soft);
}

.tree-line {
  display: block;
  width: 9px;
  height: 30px;
  border-left: 1px solid #9db2bd;
  border-bottom: 1px solid #9db2bd;
}

.relationship-main strong, .relationship-main > span {
  display: block;
}

.relationship-main strong {
  font-size: 16px;
}

.relationship-main > span:not(.semantic-badge) {
  margin: 3px 0 7px;
  color: var(--ink-500);
  font-size: 15px;
}

.relationship-row > i {
  color: #90a0a9;
  font-size: 15px;
}

.interpretation-layout {
  display: grid;
  grid-template-columns: minmax(0, 1.55fr) minmax(310px, 0.65fr);
  gap: 18px;
}

.interpretation-copy {
  margin: 0;
  padding: 19px;
  color: var(--ink-800);
  line-height: 1.72;
  white-space: pre-wrap;
}

.interpretation-note {
  display: flex;
  gap: 9px;
  padding: 11px 19px;
  color: var(--ink-650);
  border-top: 1px solid var(--line-soft);
  background: var(--surface-soft);
  font-size: 16px;
}

.retrieval-panel {
  padding: 18px;
}

.detail-list {
  margin: 12px 0 0;
}

.detail-list div {
  padding: 9px 0;
  border-bottom: 1px solid var(--line-soft);
}

.detail-list div:last-child {
  border-bottom: 0;
}

.detail-list dt {
  color: var(--ink-500);
  font-size: 15px;
  text-transform: uppercase;
}

.detail-list dd {
  margin: 4px 0 0;
  overflow-wrap: anywhere;
  font-size: 16px;
  font-weight: 650;
}

.report-document {
  overflow: hidden;
  border: 1px solid #cfd9de;
  border-radius: 7px;
  background: #fff;
}

.report-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 21px 24px;
  color: #fff;
  background: var(--navy);
}

.report-identity {
  display: flex;
  align-items: center;
  gap: 13px;
}

.report-mark {
  display: grid;
  place-items: center;
  width: 39px;
  height: 39px;
  border: 1px solid rgba(255, 255, 255, 0.28);
  background: rgba(255, 255, 255, 0.07);
}

.report-identity p {
  margin: 0;
  color: #a9c3d1;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
}

.report-identity h2 {
  margin: 3px 0;
  font-size: 20px;
  font-weight: 650;
  letter-spacing: -0.015em;
}

.report-identity span {
  color: #b9cdd7;
  font-size: 15px;
}

.report-actions .button {
  color: #fff;
  border-color: rgba(255, 255, 255, 0.4);
  background: transparent;
}

.report-actions .button:hover {
  background: rgba(255, 255, 255, 0.08);
}

.report-meta {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  margin: 0;
  border-bottom: 1px solid var(--line);
  background: #f8fafb;
}

.report-meta div {
  min-width: 0;
  padding: 11px 16px;
  border-right: 1px solid var(--line);
}

.report-meta div:last-child {
  border-right: 0;
}

.report-meta dt {
  color: var(--ink-500);
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.report-meta dd {
  margin: 3px 0 0;
  overflow: hidden;
  color: var(--ink-800);
  font-size: 15px;
  font-weight: 650;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.report-section {
  padding: 24px;
  border-bottom: 1px solid var(--line);
}

.report-section-title {
  display: grid;
  grid-template-columns: 31px 1fr;
  gap: 11px;
  align-items: start;
  margin-bottom: 17px;
}

.report-section-title > span {
  display: grid;
  place-items: center;
  width: 29px;
  height: 29px;
  color: var(--blue);
  border: 1px solid #b9d3de;
  background: var(--blue-soft);
  font-size: 14px;
  font-weight: 800;
}

.report-section-title h3 {
  margin: 0;
  font-size: 17px;
}

.report-section-title p {
  margin: 4px 0 0;
  color: var(--ink-650);
  font-size: 16px;
  line-height: 1.5;
}

.report-counts {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  margin-bottom: 16px;
  border: 1px solid var(--line);
}

.report-counts div {
  padding: 11px 14px;
  border-right: 1px solid var(--line);
}

.report-counts div:last-child {
  border-right: 0;
}

.report-counts span, .report-counts strong {
  display: block;
}

.report-counts span {
  color: var(--ink-500);
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.report-counts strong {
  margin-top: 3px;
  font-size: 19px;
}

.report-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 16px;
}

.report-table th {
  padding: 9px 11px;
  color: var(--ink-500);
  border-top: 1px solid var(--line);
  border-bottom: 1px solid var(--line-strong);
  background: #f7f9fa;
  text-align: left;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.report-table td {
  padding: 10px 11px;
  border-bottom: 1px solid var(--line-soft);
}

.report-table strong {
  font-weight: 700;
}

.seed-report {
  margin-top: 20px;
  border: 1px solid var(--line-strong);
}

.seed-report:first-of-type {
  margin-top: 0;
}

.seed-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 14px 16px;
  border-bottom: 1px solid var(--line);
  background: #f5f8f9;
}

.seed-label {
  color: var(--blue);
  font-size: 13px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.seed-header h4 {
  margin: 3px 0;
  font-size: 18px;
}

.seed-header p {
  margin: 0;
  color: var(--ink-650);
  font-size: 15px;
}

.seed-header dl {
  display: flex;
  gap: 24px;
  margin: 0;
}

.seed-header dl div {
  text-align: right;
}

.seed-header dt {
  color: var(--ink-500);
  font-size: 13px;
  text-transform: uppercase;
}

.seed-header dd {
  margin: 3px 0 0;
  font-size: 17px;
  font-weight: 750;
}

.seed-interpretation {
  margin: 0;
  padding: 13px 16px;
  color: var(--ink-800);
  border-bottom: 1px solid var(--line-soft);
  font-size: 16px;
  line-height: 1.55;
}

.report-no-evidence {
  padding: 18px 16px;
  color: var(--ink-650);
  font-size: 16px;
}

.related-report {
  padding: 16px;
  border-bottom: 1px solid var(--line);
}

.related-report:last-child {
  border-bottom: 0;
}

.related-report-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.related-designation {
  color: var(--green);
  font-size: 13px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.07em;
}

.related-report-header h5 {
  margin: 3px 0 0;
  font-size: 16px;
}

.related-test-state {
  padding: 4px 7px;
  color: #5b6870;
  border: 1px solid #d3dce0;
  background: #f3f5f6;
  font-size: 14px;
  font-weight: 650;
}

.related-summary {
  margin: 10px 0 0;
  color: var(--ink-800);
  font-size: 16px;
  line-height: 1.5;
}

.scope-note {
  margin: 6px 0 0;
  padding: 8px 10px;
  color: #735d22;
  border-left: 2px solid #c99f40;
  background: #fcf8ed;
  font-size: 15px;
  line-height: 1.5;
}

.related-test-context {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 10px;
  padding: 7px 9px;
  border: 1px solid var(--line-soft);
  background: #fafbfb;
}

.related-test-context span {
  color: var(--ink-500);
  font-size: 14px;
  text-transform: uppercase;
}

.related-test-context strong {
  font-size: 15px;
}

.evidence-report-list {
  margin-top: 11px;
  border: 1px solid var(--line);
}

.evidence-report-row {
  display: grid;
  grid-template-columns: minmax(0, 1.4fr) minmax(250px, 0.75fr) 86px;
  gap: 15px;
  align-items: center;
  padding: 12px;
  border-bottom: 1px solid var(--line-soft);
}

.evidence-report-row:last-child {
  border-bottom: 0;
}

.evidence-report-main {
  min-width: 0;
}

.evidence-report-type {
  display: flex;
  align-items: center;
  gap: 7px;
}

.evidence-report-type small {
  color: var(--ink-500);
  font-size: 13px;
}

.report-evidence-fields {
  display: flex;
  flex-wrap: wrap;
  gap: 7px 18px;
  margin: 9px 0 0;
}

.report-evidence-fields div {
  min-width: 95px;
}

.report-evidence-fields dt {
  color: var(--ink-500);
  font-size: 13px;
  text-transform: uppercase;
}

.report-evidence-fields dd {
  margin: 2px 0 0;
  font-size: 15px;
  font-weight: 650;
}

.evidence-citation {
  min-width: 0;
}

.evidence-citation strong, .evidence-citation span, .evidence-citation small {
  display: block;
}

.evidence-citation strong {
  overflow: hidden;
  font-size: 15px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.evidence-citation span {
  margin-top: 4px;
  color: var(--ink-650);
  font-size: 14px;
}

.evidence-citation small {
  margin-top: 4px;
  color: var(--ink-500);
  font-size: 13px;
  line-height: 1.4;
}

.evidence-link-button {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 7px;
  min-height: 30px;
  padding: 0 9px;
  color: var(--blue);
  border: 1px solid #b6cfd9;
  background: #fff;
  font-size: 14px;
  font-weight: 700;
}

.evidence-link-button:hover {
  background: var(--blue-soft);
}

.report-print-quote {
  display: none;
}

.report-footer {
  padding: 20px 24px;
  background: #f7f9fa;
}

.report-footer h3 {
  margin: 0;
  font-size: 15px;
}

.report-footer ul {
  margin: 9px 0 0;
  padding-left: 18px;
  color: var(--ink-650);
  font-size: 14px;
  line-height: 1.65;
}

.report-method {
  margin: 11px 0 0;
  padding-top: 10px;
  color: var(--ink-500);
  border-top: 1px solid var(--line);
  font-size: 13px;
}

.explorer-search {
  display: flex;
  gap: 10px;
  padding: 14px;
}

.search-field {
  display: flex;
  align-items: center;
  gap: 9px;
  min-width: 210px;
  height: 36px;
  padding: 0 10px;
  border: 1px solid var(--line-strong);
  border-radius: 5px;
  background: #fff;
}

.search-field.wide {
  flex: 1;
}

.search-field i {
  color: #87959e;
  font-size: 16px;
}

.search-field input {
  min-width: 0;
  width: 100%;
  padding: 0;
  color: var(--ink-950);
  border: 0;
  outline: 0;
  background: transparent;
  font-size: 15px;
}

.relationship-result {
  display: grid;
  grid-template-columns: 220px 1fr;
  min-height: 100px;
}

.result-seed {
  padding: 17px 19px;
  border-right: 1px solid var(--line);
  background: #f7fafb;
}

.result-seed span, .result-seed strong, .result-seed small {
  display: block;
}

.result-seed span {
  color: var(--ink-500);
  font-size: 14px;
  text-transform: uppercase;
}

.result-seed strong {
  margin-top: 7px;
  font-size: 18px;
}

.result-seed small {
  margin-top: 5px;
  color: var(--ink-500);
}

.result-related {
  display: flex;
  gap: 8px;
  align-items: center;
  overflow: auto;
  padding: 14px;
}

.related-node {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 2px 12px;
  min-width: 180px;
  padding: 10px 12px;
  color: inherit;
  border: 1px solid var(--line);
  border-radius: 4px;
  background: #fff;
  text-align: left;
}

.related-node strong {
  font-size: 15px;
}

.related-node span {
  color: var(--ink-500);
  font-size: 15px;
}

.related-node i {
  grid-column: 2;
  grid-row: 1/span 2;
  align-self: center;
  color: var(--blue);
}

.database-layout {
  display: grid;
  grid-template-columns: 300px minmax(0, 1fr);
  gap: 18px;
  min-height: 610px;
}

.paper-index .search-field {
  width: 100%;
  margin-top: 12px;
}

.paper-index-list {
  max-height: 530px;
  overflow: auto;
}

.paper-index-list button {
  display: block;
  width: 100%;
  padding: 12px 15px;
  color: inherit;
  border: 0;
  border-bottom: 1px solid var(--line-soft);
  background: #fff;
  text-align: left;
}

.paper-index-list button:hover {
  background: var(--surface-soft);
}

.paper-index-list button.active {
  box-shadow: inset 3px 0 var(--blue);
  background: #eff6f8;
}

.paper-index-list strong, .paper-index-list span, .paper-index-list small {
  display: block;
}

.paper-index-list strong {
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 16px;
  white-space: nowrap;
}

.paper-index-list span {
  margin-top: 5px;
  color: var(--ink-650);
  font-size: 15px;
}

.paper-index-list small {
  margin-top: 3px;
  color: var(--ink-500);
  font-size: 14px;
}

.evidence-database {
  min-width: 0;
}

.evidence-header > div {
  flex: 1;
  min-width: 0;
}

.evidence-header h3 {
  max-width: 820px;
  margin-right: 20px;
  line-height: 1.35;
  overflow-wrap: break-word;
  text-wrap: balance;
  word-break: keep-all;
}

.evidence-header .record-count {
  flex: 0 0 auto;
}

.record-count {
  color: var(--ink-500);
  font-size: 16px;
  font-variant-numeric: tabular-nums;
}

.filter-bar {
  display: flex;
  gap: 8px;
  padding: 10px 12px;
  border-bottom: 1px solid var(--line);
  background: var(--surface-soft);
}

.filter-bar select, .library-actions select, .review-source-select select, .review-form select {
  height: 34px;
  padding: 0 28px 0 10px;
  color: var(--ink-800);
  border: 1px solid var(--line-strong);
  border-radius: 4px;
  background: #fff;
  font-size: 16px;
}

.evidence-database .table-scroll {
  width: 100%;
}

.evidence-table {
  width: 100%;
  min-width: 1280px;
  table-layout: fixed;
}

.evidence-table th, .evidence-table td {
  line-height: 1.45;
  overflow: hidden;
  overflow-wrap: normal;
  text-overflow: ellipsis;
  word-break: keep-all;
}

.evidence-table th:nth-child(1) {
  width: 300px;
}

.evidence-table th:nth-child(2) {
  width: 200px;
}

.evidence-table th:nth-child(3) {
  width: 270px;
}

.evidence-table th:nth-child(4) {
  width: 170px;
}

.evidence-table th:nth-child(5) {
  width: 130px;
}

.evidence-table th:nth-child(6) {
  width: 160px;
}

.evidence-table th:nth-child(7) {
  width: 50px;
}

.evidence-table td:nth-child(1),
.evidence-table td:nth-child(2),
.evidence-table td:nth-child(4),
.evidence-table td:nth-child(5),
.evidence-table td:nth-child(6),
.evidence-table td:nth-child(7) {
  white-space: nowrap;
}

.evidence-table td:nth-child(3) {
  overflow-wrap: anywhere;
  white-space: normal;
}

.evidence-table td:nth-child(7) {
  text-align: center;
}

.evidence-table .semantic-badge, .evidence-table .status-badge {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.evidence-table tbody tr {
  cursor: pointer;
}

.literature-layout {
  display: grid;
  grid-template-columns: 335px minmax(0, 1fr);
  gap: 18px;
  align-items: start;
}

.segmented-control {
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin: 14px 19px 0;
  border: 1px solid var(--line-strong);
  border-radius: 5px;
  overflow: hidden;
}

.segmented-control button {
  min-height: 34px;
  color: var(--ink-650);
  border: 0;
  border-right: 1px solid var(--line-strong);
  background: #fff;
  font-size: 16px;
  font-weight: 650;
}

.segmented-control button:last-child {
  border-right: 0;
}

.segmented-control button.active {
  color: var(--navy);
  background: #edf4f7;
}

.registration-body {
  display: grid;
  gap: 10px;
  padding: 14px 19px;
}

.drop-zone {
  display: grid;
  place-items: center;
  min-height: 150px;
  padding: 18px;
  color: var(--ink-500);
  border: 1px dashed #aebbc2;
  background: #fafbfb;
  text-align: center;
  cursor: pointer;
}

.drop-zone:hover, .drop-zone.has-file {
  color: var(--blue);
  border-color: #7faabc;
  background: #f3f8fa;
}

.drop-zone i {
  margin-bottom: 10px;
  font-size: 23px;
}

.drop-zone strong, .drop-zone span {
  display: block;
}

.drop-zone strong {
  color: var(--ink-800);
  font-size: 15px;
}

.drop-zone span {
  margin-top: 4px;
  font-size: 15px;
}

.search-results {
  max-height: 260px;
  overflow: auto;
  border: 1px solid var(--line);
}

.search-results button {
  display: block;
  width: 100%;
  padding: 10px;
  color: inherit;
  border: 0;
  border-bottom: 1px solid var(--line-soft);
  background: #fff;
  text-align: left;
}

.search-results strong, .search-results span {
  display: block;
}

.search-results strong {
  font-size: 16px;
}

.search-results span {
  margin-top: 3px;
  color: var(--ink-500);
  font-size: 14px;
}

.registration-confirmation {
  display: grid;
  grid-template-columns: 18px 1fr auto;
  align-items: center;
  gap: 9px;
  margin: 0 19px 14px;
  padding: 11px;
  color: var(--green);
  border: 1px solid #c2dbcf;
  background: var(--green-soft);
}

.registration-confirmation strong, .registration-confirmation span {
  display: block;
}

.registration-confirmation strong {
  font-size: 15px;
}

.registration-confirmation span {
  margin-top: 2px;
  font-size: 14px;
}

.queue-status {
  margin: 0 19px 14px;
  padding: 10px;
  border: 1px solid var(--line);
  background: var(--surface-soft);
}

.queue-status p {
  margin: 6px 0 0;
  color: var(--ink-650);
  font-size: 15px;
}

.library-actions {
  display: flex;
  gap: 8px;
}

.literature-table {
  min-width: 880px;
}

.literature-table tbody tr {
  cursor: pointer;
}

.literature-table td:first-child {
  max-width: 440px;
}

.extraction-run-header {
  flex-wrap: wrap;
}

.run-tabs {
  display: flex;
  border: 1px solid var(--line-strong);
  border-radius: 4px;
  overflow: hidden;
}

.run-tabs button {
  min-height: 30px;
  padding: 0 12px;
  color: var(--ink-650);
  border: 0;
  border-right: 1px solid var(--line-strong);
  background: #fff;
  font-size: 15px;
  text-transform: uppercase;
}

.run-tabs button:last-child {
  border-right: 0;
}

.run-tabs button.active {
  color: #fff;
  background: var(--navy);
}

.run-summary-line {
  display: flex;
  flex-wrap: wrap;
  gap: 14px 22px;
  align-items: center;
  padding: 11px 19px;
  color: var(--ink-650);
  border-bottom: 1px solid var(--line);
  background: var(--surface-soft);
  font-size: 15px;
}

.run-summary-line strong {
  flex: 1;
  min-width: 300px;
  color: var(--ink-800);
  font-size: 16px;
}

.review-master-detail {
  display: grid;
  grid-template-columns: 310px minmax(0, 1fr);
  min-height: 470px;
}

.record-list {
  min-width: 0;
  border-right: 1px solid var(--line);
  background: #fafbfb;
}

.compact-filter {
  padding: 8px;
}

.compact-filter button {
  min-height: 28px;
  padding: 0 9px;
  color: var(--ink-650);
  border: 1px solid var(--line-strong);
  border-radius: 3px;
  background: #fff;
  font-size: 14px;
}

.compact-filter button.active {
  color: #fff;
  border-color: var(--navy);
  background: var(--navy);
}

.record-list-row {
  display: block;
  width: 100%;
  padding: 11px 13px;
  color: inherit;
  border: 0;
  border-bottom: 1px solid var(--line-soft);
  background: transparent;
  text-align: left;
}

.record-list-row:hover {
  background: #f3f6f7;
}

.record-list-row.active {
  box-shadow: inset 3px 0 var(--blue);
  background: #eaf3f6;
}

.record-list-row strong, .record-list-row > span, .record-list-row small {
  display: block;
}

.record-list-row strong {
  font-size: 16px;
}

.record-list-row > span {
  margin-top: 4px;
  color: var(--ink-650);
  font-size: 15px;
}

.record-list-row small {
  margin-top: 5px;
  color: var(--ink-500);
  font-size: 14px;
}

.structured-record, .review-detail {
  min-width: 0;
  padding: 19px;
}

.record-title {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 15px;
}

.record-title h3 {
  margin: 7px 0 0;
  font-size: 20px;
}

.field-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1px;
  margin: 18px 0;
  border: 1px solid var(--line);
  background: var(--line);
}

.field-grid > div {
  min-width: 0;
  padding: 10px 12px;
  background: #fff;
}

.field-grid dt {
  color: var(--ink-500);
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.field-grid dd {
  margin: 4px 0 0;
  overflow-wrap: anywhere;
  font-size: 16px;
  font-weight: 650;
}

.source-quote {
  margin: 16px 0 0;
  padding: 15px 17px;
  border-left: 3px solid var(--blue);
  background: #f4f8fa;
}

.source-quote span {
  color: var(--blue);
  font-size: 14px;
  font-weight: 750;
  letter-spacing: 0.08em;
}

.source-quote p {
  margin: 8px 0;
  color: #2e404a;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 16px;
  line-height: 1.65;
  white-space: pre-wrap;
}

.source-quote cite {
  color: var(--ink-500);
  font-family: SUIT, Arial, sans-serif;
  font-size: 15px;
  font-style: normal;
}

.issue-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 12px;
}

.issue-list span {
  padding: 4px 7px;
  color: var(--red);
  border: 1px solid #e6c2bf;
  background: var(--red-soft);
  font-size: 14px;
}

.human-review-workbench .surface-header {
  align-items: flex-end;
}

.review-source-select select {
  max-width: 440px;
}

.human-record-list {
  max-height: 660px;
  overflow: auto;
}

.source-extraction-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}

.source-document, .extracted-evidence {
  min-width: 0;
  padding: 15px;
  border: 1px solid var(--line);
}

.source-document h4, .extracted-evidence h4 {
  margin: 6px 0 10px;
  font-size: 17px;
}

.context-copy {
  max-height: 320px;
  margin: 0;
  overflow: auto;
  color: #334752;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 15px;
  line-height: 1.7;
  white-space: pre-wrap;
}

.provenance-line {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  margin: 14px 0 0;
  padding-top: 12px;
  border-top: 1px solid var(--line-soft);
}

.provenance-line dt {
  color: var(--ink-500);
  font-size: 14px;
}

.provenance-line dd {
  margin: 3px 0 0;
  overflow-wrap: anywhere;
  font-size: 15px;
  font-weight: 650;
}

.compact-fields {
  grid-template-columns: repeat(2, 1fr);
  margin: 0;
}

.review-form {
  display: grid;
  grid-template-columns: 190px minmax(0, 1fr) auto;
  gap: 12px;
  align-items: end;
  margin-top: 14px;
  padding: 14px;
  border: 1px solid var(--line);
  background: var(--surface-soft);
}

.review-form label {
  display: grid;
  gap: 5px;
  color: var(--ink-500);
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
}

.review-form select {
  width: 100%;
}

.review-form textarea {
  width: 100%;
  min-height: 62px;
  padding: 8px 10px;
  color: var(--ink-800);
  border: 1px solid var(--line-strong);
  border-radius: 4px;
  resize: vertical;
  font-size: 16px;
  line-height: 1.5;
}

.status-layout {
  display: grid;
  grid-template-columns: minmax(0, 1.35fr) minmax(330px, 0.65fr);
  gap: 18px;
}

.status-table {
  width: 100%;
  border-collapse: collapse;
}

.status-table th, .status-table td {
  padding: 14px 19px;
  border-bottom: 1px solid var(--line-soft);
  text-align: left;
  font-size: 16px;
}

.status-table th {
  width: 220px;
  color: var(--ink-650);
  font-weight: 650;
}

.status-table td:last-child {
  color: var(--ink-650);
}

.boundary-list {
  margin: 0;
  padding: 4px 19px;
}

.boundary-list div {
  padding: 13px 0;
  border-bottom: 1px solid var(--line-soft);
}

.boundary-list dt {
  color: var(--ink-500);
  font-size: 14px;
  text-transform: uppercase;
}

.boundary-list dd {
  margin: 4px 0 0;
  overflow-wrap: anywhere;
  font-size: 16px;
  font-weight: 650;
}

.system-note {
  display: flex;
  gap: 10px;
  margin: 14px 19px 19px;
  padding: 12px;
  color: #745c1e;
  border: 1px solid #e3d19e;
  background: var(--amber-soft);
}

.system-note p {
  margin: 0;
  font-size: 15px;
  line-height: 1.5;
}

.empty-state {
  display: grid;
  place-items: center;
  align-content: center;
  padding: 34px;
  color: var(--ink-500);
  border: 1px dashed #bfcbd1;
  background: rgba(255, 255, 255, 0.5);
  text-align: center;
}

.empty-state i {
  margin-bottom: 10px;
  color: #8fa1ab;
  font-size: 23px;
}

.empty-state h3 {
  margin: 0;
  color: var(--ink-800);
  font-size: 17px;
}

.empty-state p {
  max-width: 480px;
  margin: 6px 0 0;
  font-size: 16px;
  line-height: 1.5;
}

.empty-state small {
  margin-top: 5px;
  font-size: 14px;
}

.compact-empty {
  min-height: 180px;
  border: 0;
  background: transparent;
}

.table-empty {
  min-height: 120px;
  border: 0;
}

.loading-state {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  min-height: 170px;
  color: var(--ink-500);
}

.application-loading {
  width: min(1480px, 100% - 56px);
  margin: 26px auto;
}

.loading-line, .loading-table {
  overflow: hidden;
  border: 1px solid var(--line);
  background: linear-gradient(90deg, #edf1f3, #f7f9fa, #edf1f3);
  background-size: 200% 100%;
  animation: shimmer 1.6s infinite linear;
}

.loading-line {
  width: 46%;
  height: 25px;
  margin-bottom: 8px;
}

.loading-line.short {
  width: 31%;
  height: 12px;
}

.loading-table {
  height: 420px;
  margin-top: 24px;
}

@keyframes shimmer {
  to {
    background-position: -200% 0;
  }
}
.drawer-backdrop {
  position: fixed;
  inset: 0;
  z-index: 80;
  padding: 0;
  border: 0;
  background: rgba(12, 28, 38, 0.38);
}

.evidence-drawer {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 90;
  width: min(620px, 94vw);
  height: 100vh;
  overflow: auto;
  color: var(--ink-950);
  background: #fff;
  box-shadow: -18px 0 50px rgba(16, 38, 51, 0.16);
}

.drawer-header {
  position: sticky;
  top: 0;
  z-index: 2;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  padding: 20px 22px;
  border-bottom: 1px solid var(--line);
  background: #fff;
}

.drawer-header h2 {
  margin: 5px 0 10px;
  font-size: 22px;
}

.drawer-content {
  padding: 0 22px 30px;
}

.drawer-section {
  padding: 20px 0;
  border-bottom: 1px solid var(--line);
}

.drawer-section h3 {
  margin: 0 0 12px;
  font-size: 16px;
}

.drawer-fields {
  grid-template-columns: 1fr 1fr;
  margin: 0;
}

.source-quote.large p {
  font-size: 17px;
}

.source-metadata {
  display: grid;
  gap: 9px;
  margin: 13px 0;
}

.source-metadata div {
  display: grid;
  grid-template-columns: 105px 1fr;
  gap: 12px;
}

.source-metadata span {
  color: var(--ink-500);
  font-size: 15px;
}

.source-metadata strong {
  overflow-wrap: anywhere;
  font-size: 16px;
}

.support-span {
  margin: 8px 0;
  padding: 11px 13px;
  border-left: 2px solid #9ab3bf;
  background: var(--surface-soft);
}

.support-span p {
  margin: 0;
  color: var(--ink-800);
  font-family: Georgia, serif;
  font-size: 15px;
  line-height: 1.55;
}

.support-span cite {
  display: block;
  margin-top: 6px;
  color: var(--ink-500);
  font-size: 14px;
  font-style: normal;
}

.sidebar-scrim {
  display: none;
}

@media (max-width: 1180px) {
  .clinical-shell {
    grid-template-columns: 208px minmax(0, 1fr);
  }
  .app-sidebar {
    width: 208px;
  }
  .context-item {
    display: none;
  }
  .overview-grid, .patient-workbench, .literature-layout {
    grid-template-columns: 1fr;
  }
  .relationship-panel {
    min-height: auto;
  }
  .database-layout {
    grid-template-columns: 250px minmax(0, 1fr);
  }
  .status-layout {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 900px) {
  .clinical-shell {
    display: block;
  }
  .app-sidebar {
    position: fixed;
    left: -245px;
    width: 236px;
    transition: left 0.18s ease;
  }
  .app-sidebar-open {
    left: 0;
  }
  .sidebar-scrim {
    position: fixed;
    inset: 0;
    z-index: 25;
    display: block;
    padding: 0;
    border: 0;
    background: rgba(9, 27, 38, 0.35);
  }
  .mobile-menu {
    display: inline-grid;
  }
  .workspace-header {
    padding-inline: 18px;
  }
  .workspace-content {
    padding: 22px 18px 45px;
  }
  .metric-strip {
    grid-template-columns: repeat(2, 1fr);
  }
  .metric-strip > div:nth-child(2) {
    border-right: 0;
  }
  .metric-strip > div:nth-child(-n+2) {
    border-bottom: 1px solid var(--line);
  }
  .semantic-grid {
    grid-template-columns: 1fr;
  }
  .semantic-grid > div {
    border-right: 0;
    border-bottom: 1px solid var(--line-soft);
  }
  .interpretation-layout, .database-layout {
    grid-template-columns: 1fr;
  }
  .paper-index-list {
    max-height: 230px;
  }
  .review-master-detail {
    grid-template-columns: 250px minmax(0, 1fr);
  }
  .source-extraction-grid {
    grid-template-columns: 1fr;
  }
  .review-form {
    grid-template-columns: 1fr;
  }
  .evidence-report-row {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 680px) {
  :host {
    font-size: 16px;
  }
  .workspace-header {
    min-height: 58px;
  }
  .header-context .icon-button {
    margin-left: 0;
  }
  .breadcrumb {
    display: none;
  }
  .workspace-header h1 {
    font-size: 17px;
  }
  .workspace-content {
    padding: 18px 12px 36px;
  }
  .page-intro, .upload-workbench, .surface-header {
    align-items: flex-start;
    flex-direction: column;
  }
  .page-intro h2 {
    font-size: 22px;
  }
  .upload-actions {
    width: 100%;
    flex-wrap: wrap;
  }
  .upload-actions .button {
    flex: 1;
  }
  .overview-grid {
    grid-template-columns: 1fr;
  }
  .compact-run-list button {
    grid-template-columns: 1fr;
  }
  .compact-run-list dl {
    justify-content: flex-start;
  }
  .compact-run-list dl div {
    text-align: left;
  }
  .relationship-result {
    grid-template-columns: 1fr;
  }
  .result-seed {
    border-right: 0;
    border-bottom: 1px solid var(--line);
  }
  .library-actions {
    width: 100%;
    flex-direction: column;
  }
  .library-actions .search-field, .library-actions select {
    width: 100%;
  }
  .review-master-detail {
    grid-template-columns: 1fr;
  }
  .record-list {
    max-height: 260px;
    overflow: auto;
    border-right: 0;
    border-bottom: 1px solid var(--line);
  }
  .field-grid, .drawer-fields {
    grid-template-columns: 1fr 1fr;
  }
  .run-tabs {
    order: 3;
    width: 100%;
  }
  .run-tabs button {
    flex: 1;
  }
  .run-summary-line strong {
    min-width: 100%;
  }
  .status-table th, .status-table td {
    display: block;
    width: 100%;
    padding-block: 6px;
    border: 0;
  }
  .status-table tr {
    display: block;
    padding: 8px 0;
    border-bottom: 1px solid var(--line-soft);
  }
  .message-stack {
    top: 68px;
    right: 10px;
    width: calc(100vw - 20px);
  }
  .report-meta {
    grid-template-columns: 1fr 1fr;
  }
  .report-meta div:nth-child(2) {
    border-right: 0;
  }
  .report-meta div:nth-child(-n+2) {
    border-bottom: 1px solid var(--line);
  }
  .report-header, .seed-header, .related-report-header {
    align-items: flex-start;
    flex-direction: column;
  }
  .report-counts {
    grid-template-columns: 1fr;
  }
  .report-counts div {
    border-right: 0;
    border-bottom: 1px solid var(--line);
  }
  .report-counts div:last-child {
    border-bottom: 0;
  }
}
@media print {
  :host {
    height: auto;
    background: #fff;
  }
  .app-sidebar, .workspace-header, .message-stack, .page-intro, .upload-workbench,
  .patient-empty, .metric-strip, .patient-workbench, .drawer-backdrop, .evidence-drawer {
    display: none !important;
  }
  .clinical-shell, .app-workspace, .workspace-content, .page-section {
    display: block;
    width: 100%;
    margin: 0;
    padding: 0;
    background: #fff;
  }
  .report-document {
    display: block;
    border: 0;
    border-radius: 0;
  }
  .report-actions {
    display: none;
  }
  .report-header {
    color: #14212b;
    border-bottom: 2px solid #12344d;
    background: #fff;
  }
  .report-mark {
    color: #12344d;
    border-color: #12344d;
    background: #fff;
  }
  .report-identity p, .report-identity span {
    color: #50616d;
  }
  .report-section, .seed-report, .related-report, .evidence-report-row {
    break-inside: avoid;
  }
  .evidence-link-button {
    display: none;
  }
  .report-print-quote {
    display: block;
    grid-column: 1/-1;
    margin: 0;
    padding: 9px 11px;
    border-left: 2px solid #176b87;
    background: #f7f9fa;
  }
  .report-print-quote p {
    margin: 0;
    font-family: Georgia, serif;
    font-size: 9pt;
    line-height: 1.5;
  }
  .report-print-quote cite {
    display: block;
    margin-top: 5px;
    color: #50616d;
    font-size: 7.5pt;
    font-style: normal;
  }
}`],
})
export class PageHomeComponent implements OnInit {
    public workspace: string = "overview";
    public sidebarOpen: boolean = false;
    public busy: string = "";
    public error: string = "";
    public notice: string = "";

    public overview: any = {
        pipeline: {},
        runs: [],
        evidence_db: {},
        automatic_evidence_db: {},
        boundaries: {},
    };
    public dashboardData: any = { summary: {}, papers: [], queries: [], filters: {} };

    public selectedRun: any = null;
    public selectedP33Evidence: any = null;
    public p33StatusFilter: string = "accepted";

    public literatureSearch: string = "";
    public literatureStatusFilter: string = "all";
    public selectedPaper: any = null;
    public paperDetail: any = null;
    public selectedReviewEvidence: any = null;
    public reviewStatusDraft: string = "unreviewed";
    public reviewNoteDraft: string = "";

    public paperMode: string = "pdf";
    public paperFile: any = null;
    public paperSearch: string = "";
    public paperSearchResults: any[] = [];
    public registration: any = null;
    public extractionRequest: any = null;

    public patientFile: any = null;
    public classThreshold: number = 1;
    public patientData: any = null;
    public patientAnalysis: any = null;
    public llmReport: any = null;

    public evidenceQuery: string = "";
    public evidenceLookupResult: any = null;
    public evidenceRelationshipFilter: string = "all";
    public evidenceReviewFilter: string = "all";

    public drawerEvidence: any = null;
    public drawerPaper: any = null;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        const requestedView = new URLSearchParams(window.location.search).get("view");
        if (requestedView && ["overview", "patient", "explorer", "literature", "extraction", "system"].includes(requestedView)) {
            this.workspace = requestedView;
        }
        await this.loadApplication();
        if (["literature", "explorer", "extraction"].includes(this.workspace)
            && !this.selectedPaper && this.filteredPapers().length) {
            await this.selectPaper(this.filteredPapers()[0]);
        }
    }

    public async loadApplication() {
        const selectedPaperId = this.selectedPaper?.paper_id || null;
        this.busy = "application";
        this.error = "";
        await this.service.render();
        const responses: any[] = await Promise.all([
            wiz.call("admin_overview"),
            wiz.call("dashboard"),
        ]);
        const overviewResponse: any = responses[0];
        const dashboardResponse: any = responses[1];
        if (dashboardResponse.code === 200) {
            this.dashboardData = dashboardResponse.data || this.dashboardData;
            if (selectedPaperId) {
                this.selectedPaper = (this.dashboardData.papers || []).find(
                    (paper: any) => paper.paper_id === selectedPaperId
                ) || null;
            }
        }
        if (overviewResponse.code === 200) {
            this.overview = overviewResponse.data || this.overview;
            this.selectedRun = (this.overview.runs || [])[0] || null;
            this.selectDefaultP33Evidence();
        } else if (dashboardResponse.code === 200) {
            // Keep the service usable during a transient status-endpoint failure.
            // Never render missing status data as a real zero-count database.
            this.overview = {
                ...this.overview,
                evidence_db: {
                    available: undefined,
                    evidence: this.dashboardData.summary?.evidence_total,
                    concepts: undefined,
                    degraded: true,
                },
            };
        } else {
            this.error = dashboardResponse.data?.message || "문헌과 검토 자료를 불러오지 못했습니다.";
        }
        this.busy = "";
        await this.service.render();
    }

    public async setWorkspace(value: string) {
        this.workspace = value;
        this.sidebarOpen = false;
        this.error = "";
        this.notice = "";
        if (["literature", "explorer", "extraction"].includes(value)
            && !this.selectedPaper && this.filteredPapers().length) {
            await this.selectPaper(this.filteredPapers()[0]);
            return;
        }
        await this.service.render();
    }

    public async toggleSidebar() {
        this.sidebarOpen = !this.sidebarOpen;
        await this.service.render();
    }

    public pageTitle(): string {
        const values: any = {
            overview: "서비스 개요",
            patient: "알레르겐 검사 결과 해석",
            explorer: "문헌 근거 조회",
            literature: "문헌 관리",
            extraction: "문헌 정보 검토",
            system: "자료 연결 현황",
        };
        return values[this.workspace] || "Allergy Evidence Intelligence";
    }

    public dataStatusLabel(available: any): string {
        if (available === true) return "연결됨";
        if (available === false) return "이용 불가";
        return "확인 중";
    }

    public dataStatusClass(available: any): string {
        if (available === true) return "status-positive";
        if (available === false) return "status-negative";
        return "status-neutral";
    }

    public metricLabel(value: any): string {
        return typeof value === "number" ? String(value) : "—";
    }

    public async dismissMessage(type: string) {
        if (type === "error") this.error = "";
        if (type === "notice") this.notice = "";
        await this.service.render();
    }

    private async readFile(file: File): Promise<any> {
        return await new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                const encoded = String(reader.result || "").split(",").pop() || "";
                resolve({ name: file.name, size: file.size, base64: encoded });
            };
            reader.onerror = () => reject(new Error("파일을 읽지 못했습니다."));
            reader.readAsDataURL(file);
        });
    }

    public async setPaperMode(value: string) {
        this.paperMode = value;
        this.registration = null;
        this.extractionRequest = null;
        await this.service.render();
    }

    public async onPaperFile(event: any) {
        const file = event?.target?.files?.[0];
        if (!file) return;
        try {
            this.paperFile = await this.readFile(file);
            this.registration = null;
            this.extractionRequest = null;
        } catch (error) {
            this.error = String(error);
        }
        await this.service.render();
    }

    public async registerPdf() {
        if (!this.paperFile) return;
        this.busy = "register-pdf";
        this.error = "";
        await this.service.render();
        const { code, data } = await wiz.call("register_pdf", {
            filename: this.paperFile.name,
            content_base64: this.paperFile.base64,
        });
        if (code !== 200) this.error = data?.message || "PDF를 등록하지 못했습니다.";
        else {
            this.registration = data.registration;
            this.notice = "PDF를 기존 문헌 자료와 분리된 검토 보관함에 등록했습니다.";
        }
        this.busy = "";
        await this.service.render();
    }

    public async searchPaper() {
        if (!String(this.paperSearch || "").trim()) return;
        this.busy = "paper-search";
        this.error = "";
        await this.service.render();
        const { code, data } = await wiz.call("search_papers", { query: this.paperSearch });
        if (code !== 200) {
            this.error = data?.message || "논문을 검색하지 못했습니다.";
            this.paperSearchResults = [];
        } else this.paperSearchResults = data.results || [];
        this.busy = "";
        await this.service.render();
    }

    public async registerSearchResult(record: any) {
        this.busy = "register-metadata";
        this.error = "";
        await this.service.render();
        const { code, data } = await wiz.call("register_paper_metadata", { record: JSON.stringify(record) });
        if (code !== 200) this.error = data?.message || "논문 정보를 등록하지 못했습니다.";
        else {
            this.registration = data.registration;
            this.notice = this.registration?.extraction_ready
                ? "논문 정보와 공개 원문을 등록했습니다."
                : "논문 정보를 등록했습니다. 공개 원문을 확인할 수 없어 PDF 업로드가 필요합니다.";
        }
        this.busy = "";
        await this.service.render();
    }

    public async requestExtraction() {
        if (!this.registration?.registration_id) return;
        this.busy = "extraction-request";
        this.error = "";
        await this.service.render();
        const { code, data } = await wiz.call("request_p33_extraction", { registration_id: this.registration.registration_id });
        if (code !== 200) this.error = data?.message || "문헌 근거 정리 요청을 만들지 못했습니다.";
        else {
            this.extractionRequest = data.extraction_request;
            const executed = await wiz.call("run_p33_extraction", { registration_id: this.registration.registration_id });
            if (executed.code !== 200) this.error = executed.data?.message || "문헌 근거 정리를 실행하지 못했습니다.";
            else {
                this.extractionRequest = executed.data.extraction_request;
                this.notice = "논문 원문에서 문헌 근거를 추출하고 검증 결과를 저장했습니다.";
                await this.loadApplication();
                const paperId = this.extractionRequest?.paper_id || this.registration?.paper?.paper_id;
                const addedPaper = (this.dashboardData?.papers || []).find(
                    (paper: any) => paper.paper_id === paperId
                );
                if (addedPaper) await this.selectPaper(addedPaper);
            }
        }
        this.busy = "";
        await this.service.render();
    }

    public async selectRun(run: any) {
        this.selectedRun = run;
        this.p33StatusFilter = "accepted";
        this.selectDefaultP33Evidence();
        await this.service.render();
    }

    private selectDefaultP33Evidence() { this.selectedP33Evidence = this.visibleP33Evidence()[0] || null; }

    public visibleP33Evidence(): any[] {
        return (this.selectedRun?.evidence || []).filter((row: any) => {
            if (!row.quote && row.status === "rejected") return false;
            return this.p33StatusFilter === "all" || row.status === this.p33StatusFilter;
        });
    }

    public async setP33StatusFilter(value: string) {
        this.p33StatusFilter = value;
        this.selectDefaultP33Evidence();
        await this.service.render();
    }

    public async selectP33Evidence(row: any) {
        this.selectedP33Evidence = row;
        await this.service.render();
    }

    public async stageAccepted() {
        if (!this.selectedRun) return;
        this.busy = "stage";
        this.error = "";
        await this.service.render();
        const { code, data } = await wiz.call("stage_p33_accepted", { paper_key: this.selectedRun.key });
        if (code !== 200) this.error = data?.message || "조회 자료를 별도 보관하지 못했습니다.";
        else this.notice = `문헌 근거 ${data.manifest.record_count}건을 별도 보관했습니다. 현재 서비스의 문헌 자료는 변경하지 않았습니다.`;
        this.busy = "";
        await this.service.render();
    }

    public filteredPapers(): any[] {
        const term = String(this.literatureSearch || "").trim().toLowerCase();
        return (this.dashboardData?.papers || []).filter((paper: any) => {
            const searchMatches = !term || String(paper.search_text || paper.title || "").includes(term);
            const statusMatches = this.literatureStatusFilter === "all"
                || (this.literatureStatusFilter === "reviewed" && Number(paper.reviewed_count || 0) > 0)
                || (this.literatureStatusFilter === "needs_review" && Number(paper.schema_needs_review_count || 0) > 0)
                || (this.literatureStatusFilter === "fulltext" && paper.full_text_available === true);
            return searchMatches && statusMatches;
        });
    }

    public async applyLiteratureFilter(value?: string) {
        if (value) this.literatureStatusFilter = value;
        await this.service.render();
    }

    public async selectPaper(paper: any) {
        if (!paper?.paper_id) return;
        this.selectedPaper = paper;
        this.paperDetail = null;
        this.selectedReviewEvidence = null;
        this.busy = "paper-detail";
        this.error = "";
        await this.service.render();
        const { code, data } = await wiz.call("paper_detail", { paper_id: paper.paper_id });
        if (code !== 200) this.error = data?.message || "논문 상세와 문헌 근거를 불러오지 못했습니다.";
        else {
            this.paperDetail = data;
            this.prepareReviewEvidence(this.filteredPaperEvidence()[0] || null);
        }
        this.busy = "";
        await this.service.render();
    }

    public async selectPaperById(paperId: string) {
        const paper = (this.dashboardData?.papers || []).find((row: any) => row.paper_id === paperId);
        if (paper) await this.selectPaper(paper);
    }

    public filteredPaperEvidence(): any[] {
        const rows = this.paperDetail?.evidence || [];
        const term = String(this.evidenceQuery || "").trim().toLowerCase();
        return rows.filter((row: any) => {
            const relationshipMatches = this.evidenceRelationshipFilter === "all" || row.relationship_type === this.evidenceRelationshipFilter;
            const reviewMatches = this.evidenceReviewFilter === "all" || row.review_status === this.evidenceReviewFilter;
            const haystack = [row.evidence_id, row.source_allergen_raw, row.target_allergen_raw, row.source_component_raw, row.target_component_raw, row.relationship_type, row.evidence_text].filter(Boolean).join(" ").toLowerCase();
            return relationshipMatches && reviewMatches && (!term || haystack.includes(term));
        });
    }

    public relationshipOptions(): string[] {
        return Array.from(new Set((this.paperDetail?.evidence || []).map((row: any) => row.relationship_type).filter(Boolean))).sort() as string[];
    }

    public async setEvidenceFilters() {
        const visible = this.filteredPaperEvidence();
        if (this.selectedReviewEvidence && !visible.includes(this.selectedReviewEvidence)) this.prepareReviewEvidence(visible[0] || null);
        await this.service.render();
    }

    private prepareReviewEvidence(row: any) {
        this.selectedReviewEvidence = row;
        this.reviewStatusDraft = row?.review_status || "unreviewed";
        this.reviewNoteDraft = row?.review_note || "";
    }

    public async selectReviewEvidence(row: any) {
        this.prepareReviewEvidence(row);
        await this.service.render();
    }

    public async saveHumanReview() {
        if (!this.selectedPaper?.paper_id || !this.selectedReviewEvidence?.evidence_id) return;
        this.busy = "review-save";
        this.error = "";
        await this.service.render();
        const { code, data } = await wiz.call("review_evidence", {
            paper_id: this.selectedPaper.paper_id,
            evidence_id: this.selectedReviewEvidence.evidence_id,
            review_status: this.reviewStatusDraft,
            review_note: this.reviewNoteDraft,
        });
        if (code !== 200) this.error = data?.message || "검토 상태를 저장하지 못했습니다.";
        else {
            Object.assign(this.selectedReviewEvidence, data.evidence || {});
            this.notice = "원문 근거를 변경하지 않고 검토 내용을 별도로 저장했습니다.";
            await this.refreshDashboard(false);
        }
        this.busy = "";
        await this.service.render();
    }

    private async refreshDashboard(render: boolean = true) {
        const response: any = await wiz.call("dashboard");
        if (response.code === 200) this.dashboardData = response.data || this.dashboardData;
        if (render) await this.service.render();
    }

    public async onPatientFile(event: any) {
        const file = event?.target?.files?.[0];
        if (!file) return;
        try {
            this.patientFile = await this.readFile(file);
            this.patientData = null;
            this.patientAnalysis = null;
            this.llmReport = null;
        } catch (error) { this.error = String(error); }
        await this.service.render();
    }

    public async setClassThreshold(value: any) {
        const parsed = Number(value);
        this.classThreshold = Number.isFinite(parsed) ? parsed : 1;
        await this.service.render();
    }

    public async parsePatient() {
        if (!this.patientFile) return;
        this.busy = "patient-parse";
        this.error = "";
        await this.service.render();
        const { code, data } = await wiz.call("parse_patient_workbook", { filename: this.patientFile.name, content_base64: this.patientFile.base64, class_threshold: String(this.classThreshold) });
        if (code !== 200) this.error = data?.message || "Excel 검사 결과를 읽지 못했습니다.";
        else {
            this.patientData = data;
            this.patientAnalysis = null;
            this.llmReport = null;
            this.notice = `검사 결과 ${data.summary.parsed_row_count}개 항목을 불러왔습니다. Class 기준 표시는 임상적 양성 판정이 아닙니다.`;
        }
        this.busy = "";
        await this.service.render();
    }

    public async togglePatientRow(row: any) {
        row.selected = !row.selected;
        await this.service.render();
    }

    public selectedTargetCount(): number { return (this.patientData?.rows || []).filter((row: any) => row.selected).length; }

    public async analyzePatient() {
        if (!this.patientFile || !this.patientData) return;
        const targets = this.patientData.rows.filter((row: any) => row.selected).map((row: any) => row.name);
        this.busy = "patient-analysis";
        this.error = "";
        await this.service.render();
        const { code, data } = await wiz.call("analyze_patient_workbook", { filename: this.patientFile.name, content_base64: this.patientFile.base64, selected_targets: JSON.stringify(targets) });
        if (code !== 200) this.error = data?.message || "관련 문헌 근거를 조회하지 못했습니다.";
        else {
            this.patientAnalysis = data;
            this.llmReport = null;
            this.notice = `선택한 ${targets.length}개 항목에서 관련 문헌 근거 ${data.evidence_count}건을 조회했습니다.`;
        }
        this.busy = "";
        await this.service.render();
    }

    public async generatePatientReport() {
        if (!this.patientAnalysis) return;
        this.busy = "llm-report";
        this.error = "";
        await this.service.render();
        const { code, data } = await wiz.call("generate_patient_report", { analysis: JSON.stringify(this.patientAnalysis) });
        if (code !== 200) this.error = data?.message || "문헌 근거 기반 설명을 생성하지 못했습니다.";
        else {
            this.llmReport = data;
            this.notice = `조회된 문헌 근거 ${data.evidence_count}건만 사용해 설명 초안을 만들었습니다.`;
        }
        this.busy = "";
        await this.service.render();
    }

    public printPatientReport() {
        window.print();
    }

    public async lookupEvidence() {
        if (!String(this.evidenceQuery || "").trim()) return;
        this.busy = "evidence-lookup";
        this.error = "";
        await this.service.render();
        const { code, data } = await wiz.call("evidence_lookup", { allergen: this.evidenceQuery });
        if (code !== 200) {
            this.error = data?.message || "문헌 근거 자료를 조회하지 못했습니다.";
            this.evidenceLookupResult = null;
        } else this.evidenceLookupResult = data.result;
        this.busy = "";
        await this.service.render();
    }

    public async openEvidence(row: any, paper?: any) {
        this.drawerEvidence = row;
        this.drawerPaper = paper || this.selectedPaper || null;
        await this.service.render();
    }

    public async closeEvidence() {
        this.drawerEvidence = null;
        this.drawerPaper = null;
        await this.service.render();
    }

    public relationshipGroup(value: string): string {
        const clinical = ["clinical_cross_reactivity", "clinical reactivity", "reported_co_allergy"];
        const sensitization = ["ige_cross_reactivity", "cross_sensitization", "co_sensitization", "cross-sensitization", "co-sensitization"];
        const molecular = ["molecular_cross_reactivity", "molecular similarity", "sequence homology"];
        if (clinical.includes(value)) return "임상 반응 근거";
        if (sensitization.includes(value)) return "감작·IgE 근거";
        if (molecular.includes(value)) return "분자 수준 근거";
        if (value === "t_cell_cross_reactivity") return "T세포 수준 근거";
        return "기타·확인 필요";
    }

    public relationshipClass(value: string): string {
        const group = this.relationshipGroup(value);
        if (group === "임상 반응 근거") return "semantic-clinical";
        if (group === "감작·IgE 근거") return "semantic-sensitization";
        if (group === "분자 수준 근거") return "semantic-molecular";
        return "semantic-other";
    }

    public statusLabel(status: string): string {
        const labels: any = { accepted: "조회 가능", quarantine: "확인 필요", rejected: "제외", queued_for_worker: "요청 접수", verified: "확인 완료", needs_revision: "수정 필요", unreviewed: "미검토", valid: "형식 확인", invalid: "형식 오류", needs_review: "확인 필요", completed: "완료", failed: "처리 실패" };
        return labels[status] || (status ? "상태 확인 필요" : "—");
    }

    public relationshipTypeLabel(value: string): string {
        const labels: any = {
            clinical_cross_reactivity: "임상 교차반응",
            "clinical reactivity": "임상 반응",
            reported_co_allergy: "동반 알레르기 보고",
            ige_cross_reactivity: "IgE 교차반응",
            cross_sensitization: "교차 감작",
            "cross-sensitization": "교차 감작",
            co_sensitization: "동시 감작",
            "co-sensitization": "동시 감작",
            molecular_cross_reactivity: "분자 수준 교차반응",
            "molecular similarity": "분자 유사성",
            "sequence homology": "서열 유사성",
            t_cell_cross_reactivity: "T세포 교차반응",
        };
        return labels[value] || (value ? "기타 관계" : "관계 유형 미기록");
    }

    public directionLabel(value: string): string {
        const labels: any = {
            bidirectional: "양방향",
            forward: "정방향",
            reverse: "역방향",
            source_to_target: "원인 항목에서 관련 항목 방향",
            target_to_source: "관련 항목에서 원인 항목 방향",
            undetermined: "방향 미확정",
            unclear: "방향 불명확",
        };
        return labels[value] || value || "—";
    }

    public sourceAvailabilityLabel(paper: any): string {
        if (paper?.full_text_available) return "원문 보유";
        return "원문 확인 필요";
    }

    public userText(value: any): string {
        let text = String(value || "");
        const replacements: Array<[RegExp, string]> = [
            [/Accepted\/Human-verified/gi, "검증 단계 기준"],
            [/Human[- ]verified/gi, "검토 확인된"],
            [/Human Review/gi, "검토 기록"],
            [/Accepted/gi, "조회 가능한"],
            [/Evidence/gi, "문헌 근거"],
            [/provenance/gi, "출처 정보"],
            [/deterministic/gi, "규칙 기반"],
            [/\bseed\b/gi, "기준 알레르겐"],
            [/schema/gi, "자료 형식"],
            [/vector search/gi, "추가 문헌 검색"],
            [/exact lookup/gi, "일치 근거 조회"],
            [/pipeline/gi, "처리 과정"],
            [/candidate/gi, "검토 항목"],
            [/structuring/gi, "정보 정리"],
            [/\bP\d{2}(?:-\d+)?\b/gi, "내부 처리"],
            [/GPT-[\w.-]+/gi, "자동 정리 도구"],
            [/Terra|Mini/gi, "자동 정리 도구"],
        ];
        replacements.forEach(([pattern, replacement]) => { text = text.replace(pattern, replacement); });
        return text;
    }

    public issueLabel(issue: string): string {
        const labels: any = {
            conflicting_numeric_shape: "보고 수치 형식 충돌",
            incomplete_range: "보고 범위 값 불완전",
            missing_provenance: "근거 출처 확인 필요",
            unsupported_direction: "방향성 근거 확인 필요",
            missing_support_span: "연결된 원문 확인 필요",
            duplicate: "중복 가능성 확인 필요",
        };
        return labels[issue] || "추가 확인 필요";
    }

    public statusClass(status: string): string {
        if (["accepted", "verified", "valid", "completed"].includes(status)) return "status-positive";
        if (["quarantine", "needs_revision", "needs_review", "queued_for_worker"].includes(status)) return "status-review";
        if (["rejected", "invalid", "failed"].includes(status)) return "status-negative";
        return "status-neutral";
    }

    public evidencePair(row: any): string {
        const source = row?.source_allergen_raw || row?.source_allergen || row?.seed_allergen;
        const target = row?.target_allergen_raw || row?.target_allergen || row?.related_allergen;
        return [source, target].filter(Boolean).join(" → ") || "알레르겐 관계 미기록";
    }

    public evidenceComponents(row: any): string {
        const source = row?.source_component_raw || row?.source_component;
        const target = row?.target_component_raw || row?.target_component;
        if (!source && !target) return "—";
        return `${source || "—"} ↔ ${target || "—"}`;
    }

    public evidenceRate(row: any): string {
        if (row?.rate) return String(row.rate);
        if (row?.rate_text_raw) return String(row.rate_text_raw);
        if (row?.rate_value !== null && row?.rate_value !== undefined) {
            const prefix: any = { greater_than: ">", greater_than_or_equal: "≥", less_than: "<", less_than_or_equal: "≤", up_to: "≤" };
            return `${prefix[row.rate_operator] || ""}${row.rate_value}${row.rate_unit || ""}`;
        }
        if (row?.rate_value_min !== null && row?.rate_value_min !== undefined) return `${row.rate_value_min}–${row.rate_value_max}${row.rate_unit || ""}`;
        return "—";
    }

    public evidenceQuote(row: any): string { return row?.evidence_text || row?.quote || ""; }

    public evidenceLocation(row: any): string {
        return row?.evidence_location || row?.location || row?.source_location || [row?.section, row?.page ? `페이지 ${row.page}` : null, row?.table].filter(Boolean).join(" · ") || "—";
    }

    public sourceUrl(row: any, paper?: any): string | null {
        const metadata = paper || this.drawerPaper || {};
        const doi = row?.DOI || row?.doi || metadata?.doi;
        const pmid = row?.PMID || row?.pmid || metadata?.pmid;
        if (doi) return `https://doi.org/${String(doi).replace(/^https?:\/\/(dx\.)?doi\.org\//i, "")}`;
        if (pmid) return `https://pubmed.ncbi.nlm.nih.gov/${pmid}/`;
        return metadata?.external_links?.europe_pmc || metadata?.external_links?.pmc || null;
    }

    public formatMoney(value: any): string {
        const amount = Number(value);
        return Number.isFinite(amount) ? `$${amount.toFixed(3)}` : "—";
    }

    public formatSize(bytes: number): string {
        if (!Number.isFinite(Number(bytes))) return "—";
        if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
        return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
    }

    public formatDate(value: any): string {
        if (!value) return "—";
        const date = new Date(value);
        return Number.isNaN(date.getTime()) ? String(value) : date.toLocaleDateString("ko-KR");
    }

    public trackRun(index: number, row: any) { return row.key || index; }
    public trackEvidence(index: number, row: any) { return row.record_id || row.evidence_id || index; }
    public trackPatient(index: number, row: any) { return row.row_id || index; }
    public trackSearch(index: number, row: any) { return row.paper_id || row.doi || index; }
    public trackPaper(index: number, row: any) { return row.paper_id || index; }
}

export default PageHomeComponent;